// use client: activeStepIndex is local UI state — the selected step drives both
// the accordion's activeKey and which step image is shown, so the image column
// and the accordion column are one interactive unit.
'use client'

import { useState } from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'

import { parseCmsHtml } from '@/utils'

interface Step {
  stepNumber?: string | number
  stepTitle?: string
  stepContent?: string
  stepImageUrl?: string
}

interface StepsAccordionProps {
  steps?: Step[]
  /** Step-title heading classes — differs slightly between host pages. */
  titleClassName?: string
  /** Extra classes for the accordion body, when the host page adds spacing. */
  bodyClassName?: string
}

function StepsAccordion({
  steps = [],
  titleClassName = 'fw-bold fs-md-18 fs-16 m-0',
  bodyClassName
}: StepsAccordionProps) {
  const [activeStepIndex, setActiveStepIndex] = useState(0)

  return (
    <Row className="g-5">
      <Col xl={5} md={12}>
        {steps?.[activeStepIndex] && (
          <img
            src={steps[activeStepIndex].stepImageUrl}
            alt={`Step ${activeStepIndex + 1}`}
            className="img-fluid rounded-4 w-100"
          />
        )}
      </Col>

      <Col xl={7} md={12}>
        <Accordion
          activeKey={String(activeStepIndex)}
          onSelect={eventKey => setActiveStepIndex(Number(eventKey))}
          className="place-td-accordion"
        >
          {(steps ?? []).map((step, index) => (
            <Accordion.Item eventKey={String(index)} key={step.stepNumber}>
              <Accordion.Header as="div" className="p-0">
                <div className="step-header d-flex align-items-md-center gap-md-3 gap-2">
                  <span className="step-number-circle">{step.stepNumber}</span>
                  <h3 className={titleClassName}>{step.stepTitle}</h3>
                </div>
              </Accordion.Header>
              <Accordion.Body className={bodyClassName}>
                <p className="mb-0 fs-md-16 fs-14">
                  {step.stepContent && parseCmsHtml(step.stepContent)}
                </p>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Col>
    </Row>
  )
}

export default StepsAccordion
